module.exports = __webpack_public_path__ + "static/evans-county-boe-ce862889789f4c2c8e6162be90fc6a7c.jpg";